function buildIndexes(elements) {
    const byId = new Map();
    const children = new Map();
    for (const el of elements)
        byId.set(el.id, el);
    for (const el of elements) {
        const p = el.parentElementId || "";
        if (!children.has(p))
            children.set(p, []);
        children.get(p).push(el);
    }
    return { byId, children };
}
export function getFlattenedSubtree(elements, startId) {
    const { byId, children } = buildIndexes(elements);
    const start = byId.get(startId);
    if (!start)
        return [];
    const visited = new Set();
    const result = [];
    const walk = (id) => {
        if (visited.has(id))
            return;
        visited.add(id);
        const el = byId.get(id);
        if (!el)
            return;
        result.push(el);
        for (const child of children.get(id) ?? []) {
            walk(child.id);
        }
    };
    walk(startId);
    return result;
}
//# sourceMappingURL=graph.js.map